import React from "react";
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  Container,
  Typography,
  Grid,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneIcon from "@mui/icons-material/Phone";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import img2 from "../assets/img/logo.jpeg"; // Import your logo
import { Link } from "react-router-dom"; // Import Link from react-router-dom

function Navbar({ darkMode }) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{
        textAlign: "center",
        bgcolor: darkMode ? "#000" : "#fff",
        color: darkMode ? "#fff" : "#000",
        height: "100%",
      }}
    >
      <Box my={2}>
        <img
          src={img2}
          alt="Fincal Business Solutions Logo"
          style={{ maxWidth: "80px" }}
        />
      </Box>
      <List>
        {["Home", "About", "Features", "Services", "Contact"].map((text) => (
          <ListItem button key={text} sx={{ textTransform: "uppercase" }}>
            <ListItemText
              primary={text}
              sx={{
                "& .MuiTypography-root": {
                  fontWeight: "bold",
                  color: darkMode ? "#fff" : "#000",
                },
              }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <header>
      {/* Header Top with Contact and Social Icons */}
      <Box
        sx={{
          bgcolor: darkMode ? "#333" : "#f9f9f9",
          color: darkMode ? "#fff" : "#000",
          py: 1,
          fontSize: "14px",
        }}
      >
        <Container>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={6}>
              <Typography
                component="span"
                sx={{ mx: 1, display: "flex", alignItems: "center" }}
              >
                <PhoneIcon sx={{ mr: 1 }} /> +254 719269649
              </Typography>
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              {/* Social Media Icons */}
              <IconButton
                color="inherit"
                href="https://www.facebook.com/profile.php?id=61567810401210"
                sx={{ color: darkMode ? "#f0f0f0" : "#3b5998", mx: 0.5 }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                color="inherit"
                href="https://www.linkedin.com/in/fincal-business-solutions-67a656334/"
                sx={{ color: darkMode ? "#f0f0f0" : "#0077b5", mx: 0.5 }}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                color="inherit"
                href="https://wa.me/+254719269649"
                sx={{ color: darkMode ? "#f0f0f0" : "#25D366", mx: 0.5 }}
              >
                <WhatsAppIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Middle Section with Logo and Navigation */}
      <Box
        sx={{
          bgcolor: darkMode ? "#000" : "#fff",
          color: darkMode ? "#fff" : "#000",
          py: 2,
          borderBottom: "1px solid #ccc",
        }}
      >
        <Container>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={6}>
              {/* Logo with Link to Home */}
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Link
                  to="/"
                  style={{
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={img2}
                    alt="Fincal Business Solutions Logo"
                    style={{ maxWidth: "60px" }}
                  />
                  <Typography
                    variant="h6"
                    component="h1"
                    sx={{
                      ml: 2,
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                      color: "#0f2027",
                    }}
                  >
                    Fincal Business Solutions
                  </Typography>
                </Link>
              </Box>
            </Grid>

            {/* Main Navigation */}
            <Grid item xs={6}>
              <AppBar
                position="static"
                sx={{
                  backgroundColor: darkMode
                    ? "linear-gradient(to right, #0f2027, #203a43, #2c5364)"
                    : "#f57c00",
                  boxShadow: "none",
                  height: "60px",
                  justifyContent: "center",
                  transition: "background-color 0.3s ease",
                }}
              >
                <Toolbar
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    minHeight: "60px",
                  }}
                >
                  {/* Mobile Menu */}
                  {isMobile ? (
                    <>
                      <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={handleDrawerToggle}
                      >
                        <MenuIcon />
                      </IconButton>
                      <Drawer
                        anchor="right"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                      >
                        {drawer}
                      </Drawer>
                    </>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "20px",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                      }}
                    >
                      {[ "About", "Services", "Contact"].map((link) => (
                        <Button
                          key={link}
                          color="inherit"
                          href={`/${link.toLowerCase()}`}
                          sx={{
                            color: "inherit",
                            "&:hover": {
                              backgroundColor: darkMode
                                ? "#1c313a"
                                : "#ffcc80",
                            },
                          }}
                        >
                          {link}
                        </Button>
                      ))}
                    </Box>
                  )}
                </Toolbar>
              </AppBar>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </header>
  );
}

export default Navbar;
